import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
//import ImageUpload from "../../components/imageUpload.js";

const SdpServiceEdit = ()=>{
     const [serviceName, setServiceName ] = useState('');
     const [shortCode, setShortCode ] = useState('');
     const [offerCode, setOfferCode ] = useState('');
     const [cost, setCost ] = useState('');
     const [keyword, setKeyword ] = useState('');
     const [client, setClient ] = useState('');
     const [serviceType, setServiceType ] = useState('');
     const [clientInputUrl, setClientInputUrl ] = useState('');
     const [clientDlrUrl, setClientDlrUrl ] = useState('');
     const [sdpInputUrl, setSdpInputUrl ] = useState('');
     const [sdpDlrUrl, setSdpDlrUrl ] = useState('');
     const [createdAt, setCreatedAt ] = useState('');
     const [updateAt, setUpdateAt ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`sdpService/${id}`);
                 setServiceName(data.service_name);
                 setShortCode(data.short_code);
                 setOfferCode(data.offer_code);
                 setCost(data.cost);
                 setKeyword(data.keyword);
                 setClient(data.client);
                 setServiceType(data.service_type);
                 setClientInputUrl(data.client_input_url);
                 setClientDlrUrl(data.client_dlr_url);
                 setSdpInputUrl(data.sdp_input_url);
                 setSdpDlrUrl(data.sdp_dlr_url);
                 setCreatedAt(data.created_at);
                 setUpdateAt(data.update_at);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`sdpService/${id}`, {
            serviceName,
            shortCode,
            offerCode,
            cost,
            keyword,
            client,
            serviceType,
            clientInputUrl,
            clientDlrUrl,
            sdpInputUrl,
            sdpDlrUrl,
            createdAt,
            updateAt,
        });
        console.log(data);
        setRedirect(true);
    };
//     const updateImage = (url) =>{
//         if(ref.current){
//             ref.current.value = url;
//         }
// setLogoImage(url);
//     }
    if(redirect){
         return <Navigate to={'/sdpService'} />
    }
    return (
        <Wrapper pageTitle={'Edit SdpService'}>
            <InnerNav createLink={'/sdpServiceCreate'} listLink={'/sdpService'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ServiceName </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ServiceName" value={serviceName}
                        onChange = {e => setServiceName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ShortCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ShortCode" value={shortCode}
                        onChange = {e => setShortCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">OfferCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="OfferCode" value={offerCode}
                        onChange = {e => setOfferCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Cost </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Cost" value={cost}
                        onChange = {e => setCost(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Keyword </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Keyword" value={keyword}
                        onChange = {e => setKeyword(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Client </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Client" value={client}
                        onChange = {e => setClient(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ServiceType </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ServiceType" value={serviceType}
                        onChange = {e => setServiceType(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ClientInputUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ClientInputUrl" value={clientInputUrl}
                        onChange = {e => setClientInputUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ClientDlrUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ClientDlrUrl" value={clientDlrUrl}
                        onChange = {e => setClientDlrUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SdpInputUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SdpInputUrl" value={sdpInputUrl}
                        onChange = {e => setSdpInputUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SdpDlrUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SdpDlrUrl" value={sdpDlrUrl}
                        onChange = {e => setSdpDlrUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">CreatedAt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="CreatedAt" value={createdAt}
                        onChange = {e => setCreatedAt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">UpdateAt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="UpdateAt" value={updateAt}
                        onChange = {e => setUpdateAt(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default SdpServiceEdit;